/** `document` module DTOs unique keys */
export enum DocumentDtoKeysEnum {
  /** ABC-analysis API response body */
  ABC_ANALYSIS_PAGE_DTO = 'document/abc-analysis-page.dto',
  /** ABC analysis grouping criteria */
  ABC_ANALYSIS_BY_DTO = 'document/abc-analysis-by.dto',
  /** ABC-analysis API query parameters */
  ABC_ANALYSIS_QUERY_DTO = 'document/abc-analysis-query.dto',
  /** ABC-analysis API report item */
  ABC_ANALYSIS_ROW_DTO = 'document/abc-analysis-row.dto',
  /** ABC-analysis widget API query parameters */
  ABC_ANALYSIS_WIDGET_QUERY_DTO = 'document/abc-analysis-widget-query.dto',
  /** ABC analysis registry API response body */
  ABC_ANALYSIS_ITEMS_PAGE_DTO = 'document/abc-analysis-items-page.dto',
  /** ABC analysis registry column selection parameters */
  ABC_ANALYSIS_SELECT_DTO = 'document/abc-analysis-select.dto',
  /** ABC analysis registry sorting settings */
  ABC_ANALYSIS_SORT_DTO = 'document/abc-analysis-sort.dto',
  /** ABC analysis total API query parameters */
  ABC_ANALYSIS_TOTAL_QUERY_DTO = 'document/abc-analysis-total-query.dto',
  /** ABC analysis total values */
  ABC_ANALYSIS_TOTAL_DATA_DTO = 'document/abc-analysis-total-data.dto',
  /** ABC analysis total API response body */
  ABC_ANALYSIS_TOTAL_DTO = 'document/abc-analysis-total.dto',
  /** ABC analysis registry export to file API query parameters */
  ABC_ANALYSIS_EXPORT_QUERY_DTO = 'document/abc-analysis-export-query.dto',
  /** Bank statement rule condition response body */
  BANK_STATEMENT_RULE_CONDITION_FIND_DTO = 'document/bank-statement-rule-condition-find.dto',
  /** Bank statement rule create and update API's condition request body */
  BANK_STATEMENT_RULE_CONDITION_FORM_DTO = 'document/bank-statement-rule-condition-form.dto',
  /** Bank statement rule expression response body */
  BANK_STATEMENT_RULE_EXPRESSION_FIND_DTO = 'document/bank-statement-rule-expression-find.dto',
  /** Bank statement rule create and update API's expression request body */
  BANK_STATEMENT_RULE_EXPRESSION_FORM_DTO = 'document/bank-statement-rule-expression-form.dto',
  /** Bank statement rule response body */
  BANK_STATEMENT_RULE_FIND_DTO = 'document/bank-statement-rule-find.dto',
  /** Bank statement rule create and update API's request body */
  BANK_STATEMENT_RULE_FORM_DTO = 'document/bank-statement-rule-form.dto',
  /** Bank statement rule registry filters */
  BANK_STATEMENT_RULE_FILTERS_DTO = 'document/bank-statement-rule-filters.dto',
  /** Bank statement rule registry items page */
  BANK_STATEMENT_RULE_PAGE_DTO = 'document/bank-statement-rule-page.dto',
  /** Bank statement rule registry API query parameters */
  BANK_STATEMENT_RULE_QUERY_DTO = 'document/bank-statement-rule-query.dto',
  /** Bank statement rule registry column selection parameters */
  BANK_STATEMENT_RULE_SELECT_DTO = 'document/bank-statement-rule-select.dto',
  /** Bank statement rule registry sorting settings */
  BANK_STATEMENT_RULE_SORT_DTO = 'document/bank-statement-rule-sort.dto',
  /** Bank statement rule registry export to file API query parameters */
  BANK_STATEMENT_RULE_EXPORT_QUERY_DTO = 'document/bank-statement-rule-export-query.dto',
  /** Cash-Flow Analysis widget API response body */
  CASH_FLOW_ANALYSIS_FIND_DTO = 'document/cash-flow-analysis-find.dto',
  /** Cash-Flow Analysis widget API query parameters */
  CASH_FLOW_ANALYSIS_QUERY_DTO = 'document/cash-flow-analysis-query.dto',
  /** Document exchange filter response body */
  DOCUMENT_EXCHANGE_FILTER_FIND_DTO = 'document/document-exchange-filter-find.dto',
  /** Document exchange filter create or update APIs request body */
  DOCUMENT_EXCHANGE_FILTER_FORM_DTO = 'document/document-exchange-filter-form.dto',
  DOCUMENT_HISTORY_FIND_DTO = 'document/document-history-find.dto',
  DOCUMENT_HISTORY_PAGE_DTO = 'document/document-history-page.dto',
  OPERATION_TYPE_HISTORY_FIND_DTO = 'document/operation-type-history-find.dto',
  OPERATION_TYPE_HISTORY_PAGE_DTO = 'document/operation-type-history-page.dto',
  /** Operation type base filters */
  OPERATION_TYPE_FILTERS_DTO = 'document/operation-type-filters.dto',
  /** Operation type find one API additional options */
  OPERATION_TYPE_FIND_ONE_OPTIONS_DTO = 'document/operation-type-find-one-options.dto',
  OPERATION_TYPE_FIND_ALL_QUERY_DTO = 'document/operation-type-find-all-query.dto',
  OPERATION_TYPE_FIND_PAGE_QUERY_DTO = 'document/operation-type-find-page-query.dto',
  /** Operation type response body */
  OPERATION_TYPE_FIND_DTO = 'document/operation-type-find.dto',
  OPERATION_TYPE_FORM_DTO = 'document/operation-type-form.dto',
  OPERATION_TYPE_PAGE_DTO = 'document/operation-type-page.dto',
  /** Operation type hierarchy registry selectable columns */
  OPERATION_TYPE_HIERARCHY_REGISTRY_SELECTABLE_ITEM_DTO = 'document/operation-type-hierarchy-registry-selectable-item.dto',
  /** Operation type flat registry selectable columns */
  OPERATION_TYPE_FLAT_REGISTRY_SELECTABLE_ITEM_DTO = 'document/operation-type-flat-registry-selectable-item.dto',
  /** Operation type registry column selection */
  OPERATION_TYPE_SELECT_DTO = 'document/operation-type-select.dto',
  /** Operation type registry sorting */
  OPERATION_TYPE_SORT_DTO = 'document/operation-type-sort.dto',
  /** Operation type registry query */
  OPERATION_TYPE_REGISTRY_QUERY_DTO = 'document/operation-type-registry-query.dto',
  /** Operation type registry filters DTO */
  OPERATION_TYPE_REGISTRY_FILTERS_DTO = 'document/operation-type-registry-filters.dto',
  /** Operation type registry items page */
  OPERATION_TYPE_ITEMS_PAGE_DTO = 'document/operation-type-items-page.dto',
  DOCUMENT_TYPE_HISTORY_FIND_DTO = 'document/document-type-history-find.dto',
  DOCUMENT_TYPE_HISTORY_PAGE_DTO = 'document/document-type-history-page.dto',
  DOCUMENT_COMPARE_QUERY_DTO = 'document/document-compare-query.dto',
  DOCUMENT_COMPARE_AMOUNT_DTO = 'document/document-compare-amount.dto',
  DOCUMENT_COMPARE_RESULT_DTO = 'document/document-compare-result.dto',
  DOCUMENT_COMPARE_ITEM_DTO = 'document/document-compare-item.dto',
  DOCUMENT_COMPARE_REPORT_DTO = 'document/document-compare-report.dto',
  /** Document compare registry row find */
  DOCUMENT_COMPARE_REGISTRY_ROW_FIND_DTO = 'document/document-compare-registry-row-find.dto',
  /** Document compare registry row */
  DOCUMENT_COMPARE_REGISTRY_ROW_DTO = 'document/document-compare-registry-row.dto',
  /** Document compare select */
  DOCUMENT_COMPARE_SELECT_DTO = 'document/document-compare-select.dto',
  /** Document compare items query */
  DOCUMENT_COMPARE_ITEMS_QUERY_DTO = 'document/document-compare-items-query.dto',
  /** Document compare page */
  DOCUMENT_COMPARE_PAGE_DTO = 'document/document-compare-page.dto',
  /** Document compare registry export to file API query parameters */
  DOCUMENT_COMPARE_EXPORT_QUERY_DTO = 'document/document-compare-export-query.dto',
  /** Document analytics reset report own filters */
  DOCUMENT_ANALYTICS_RESET_REPORT_FILTERS_DTO = 'document/document-analytics-reset-report-filters.dto',
  /** Document analytics reset report item response body */
  DOCUMENT_ANALYTICS_RESET_REPORT_ITEM_DTO = 'document/document-analytics-reset-report-item.dto',
  /** Document analytics reset report main API response body */
  DOCUMENT_ANALYTICS_RESET_REPORT_PAGE_DTO = 'document/document-analytics-reset-report-page.dto',
  /** Document analytics reset report main API query parameters */
  DOCUMENT_ANALYTICS_RESET_REPORT_QUERY_DTO = 'document/document-analytics-reset-report-query.dto',
  /** Document analytics reset report items sorting settings */
  DOCUMENT_ANALYTICS_RESET_REPORT_SORT_DTO = 'document/document-analytics-reset-report-sort.dto',
  /** Document analytics reset report column selection */
  DOCUMENT_ANALYTICS_RESET_REPORT_SELECT_DTO = 'document/document-analytics-reset-report-select.dto',
  /** Document analytics reset report subtotal API response body */
  DOCUMENT_ANALYTICS_RESET_REPORT_SUBTOTAL_DTO = 'document/document-analytics-reset-report-subtotal.dto',
  /** Document analytics reset report subtotal own filters */
  DOCUMENT_ANALYTICS_RESET_REPORT_SUBTOTAL_FILTERS_DTO = 'document/document-analytics-reset-report-subtotal-filters.dto',
  /** Document analytics reset report subtotal item response body */
  DOCUMENT_ANALYTICS_RESET_REPORT_SUBTOTAL_ITEM_DTO = 'document/document-analytics-reset-report-subtotal-item.dto',
  /** Document analytics reset report subtotal API query parameters */
  DOCUMENT_ANALYTICS_RESET_REPORT_SUBTOTAL_QUERY_DTO = 'document/document-analytics-reset-report-subtotal-query.dto',
  /** Document analytics reset report total values */
  DOCUMENT_ANALYTICS_RESET_REPORT_TOTAL_DATA_DTO = 'document/document-analytics-reset-report-total-data.dto',
  /** Document analytics reset report total API response body */
  DOCUMENT_ANALYTICS_RESET_REPORT_TOTAL_DTO = 'document/document-analytics-reset-report-total.dto',
  /** Document analytics reset report total API query parameters */
  DOCUMENT_ANALYTICS_RESET_REPORT_TOTAL_QUERY_DTO = 'document/document-analytics-reset-report-total-query.dto',
  /** Document analytics reset report registry export to file API query parameters */
  DOCUMENT_ANALYTICS_RESET_REPORT_EXPORT_QUERY_DTO = 'document/document-analytics-reset-report-export-query.dto',
  CONTRACT_1C_SYNC_QUERY_DTO = 'document/contract-1c-sync-query.dto',
  CONTRACT_FIND_DTO = 'document/contract-find.dto',
  CONTRACT_FORM_DTO = 'document/contract-form.dto',
  CONTRACT_CREATE_DTO = 'document/contract-create.dto',
  /** Contracts to fill analytical features API own filters */
  CONTRACT_ANALYTICAL_FEATURES_FILTERS_DTO = 'document/contract-analytical-features-filters.dto',
  /** Contracts to fill analytical features item response body */
  CONTRACT_ANALYTICAL_FEATURES_ITEM_DTO = 'document/contract-analytical-features-item.dto',
  /** Contracts to fill analytical features API response body */
  CONTRACT_ANALYTICAL_FEATURES_PAGE_DTO = 'document/contract-analytical-features-page.dto',
  /** Contracts to fill analytical features API query parameters */
  CONTRACT_ANALYTICAL_FEATURES_QUERY_DTO = 'document/contract-analytical-features-query.dto',
  /** Contract bulk update API request body */
  CONTRACT_BULK_UPDATE_FORM_DTO = 'document/contract-bulk-update-form.dto',
  /** Contract bulk update item (single contract request body) */
  CONTRACT_BULK_UPDATE_ITEM_DTO = 'document/contract-bulk-update-item.dto',
  /** Contract registry business filters */
  CONTRACT_OWN_FILTERS_DTO = 'document/contract-own-filters.dto',
  /** Contract registry column selection parameters */
  CONTRACT_SELECT_DTO = 'document/contract-select.dto',
  /** Contract registry sorting settings */
  CONTRACT_SORT_DTO = 'document/contract-sort.dto',
  /** Contract registry API query parameters */
  CONTRACT_ITEMS_QUERY_DTO = 'document/contract-items-query.dto',
  /** Contract analytics settings */
  CONTRACT_ANALYTICS_SETTINGS_DTO = 'document/contract-analytics-settings.dto',
  /** Contract analytics query parameters */
  CONTRACT_ANALYTICS_QUERY_DTO = 'document/contract-analytics-query.dto',
  /** Contract find one API additional query parameters */
  CONTRACT_FIND_ONE_QUERY_DTO = 'document/contract-find-one-query.dto',
  /** Contract list API query parameters */
  CONTRACT_QUERY_DTO = 'document/contract-query.dto',
  /** Contract registry API response body */
  CONTRACT_PAGE_DTO = 'document/contract-page.dto',
  /** Contract registry: row «Expiring» in analytics */
  CONTRACT_REGISTRY_ANALYTICS_EXPIRING_ITEM_DTO = 'document/contract-registry-analytics-expiring-item.dto',
  /** Contract registry: row «Top by rent» in analytics */
  CONTRACT_REGISTRY_ANALYTICS_TOP_RENT_ITEM_DTO = 'document/contract-registry-analytics-top-rent-item.dto',
  /** Contract registry: analytics response */
  CONTRACT_REGISTRY_ANALYTICS_DTO = 'document/contract-registry-analytics.dto',
  CONTRACT_HISTORY_FIND_DTO = 'document/contract-history-find.dto',
  CONTRACT_HISTORY_PAGE_DTO = 'document/contract-history-page.dto',
  /** Contract settings common request and response body */
  CONTRACT_SETTINGS_DTO = 'document/contract-settings.dto',
  CONTRACT_SWITCH_STATUS_DTO = 'document/contract-switch-status.dto',
  SALARY_DISTRIBUTION_USER_FIND_DTO = 'document/salary-distribution-user-find.dto',
  SALARY_DISTRIBUTION_USER_FORM_DTO = 'document/salary-distribution-user-form.dto',
  SALARY_DISTRIBUTION_DIRECTION_SETTINGS_FORM_DTO = 'document/salary-distribution-direction-settings-form.dto',
  SALARY_DISTRIBUTION_UNIT_SETTINGS_FORM_DTO = 'document/salary-distribution-unit-settings-form.dto',
  SALARY_DISTRIBUTION_FILIAL_SETTINGS_FORM_DTO = 'document/salary-distribution-filial-settings-form.dto',
  SALARY_DISTRIBUTION_ANALYTICAL_FEATURE_SETTINGS_DTO = 'document/salary-distribution-analytical-feature-settings.dto',
  SALARY_DISTRIBUTION_FIND_DTO = 'document/sale-distribution-find.dto',
  SALARY_DISTRIBUTION_FORM_DTO = 'document/sale-distribution-form.dto',
  SALARY_DISTRIBUTION_SELECT_DTO = 'document/salary-distribution-select.dto',
  SALARY_DISTRIBUTION_SORT_DTO = 'document/salary-distribution-sort.dto',
  SALARY_DISTRIBUTION_QUERY_DTO = 'document/salary-distribution-query.dto',
  /** Salary distribution registry export to file API query parameters */
  SALARY_DISTRIBUTION_EXPORT_QUERY_DTO = 'document/salary-distribution-export-query.dto',
  SALARY_DISTRIBUTION_PAGE_DTO = 'document/salary-distribution-page.dto',
  SALARY_DISTRIBUTION_STAT_ITEM_DTO = 'document/salary-distribution-stat-item.dto',
  SALARY_DISTRIBUTION_STAT_DTO = 'document/salary-distribution-stat.dto',
  /** Salary accrual find API request body */
  SALARY_ACCRUAL_FIND_DTO = 'document/salary-accrual-find.dto',
  /** Salary accrual form API request body */
  SALARY_ACCRUAL_FORM_DTO = 'document/salary-accrual-form.dto',
  /** Salary accrual group form API request body */
  SALARY_ACCRUAL_GROUP_FORM_DTO = 'document/salary-accrual-group-form.dto',
  /** Salary accrual repeat form API request body */
  SALARY_ACCRUAL_REPEAT_FORM_DTO = 'document/salary-accrual-repeat-form.dto',
  /** Salary accrual bind documents API request body */
  SALARY_ACCRUAL_BIND_DOCUMENTS_DTO = 'document/salary-accrual-bind-documents.dto',
  /** Salary accrual own filters API request body */
  SALARY_ACCRUAL_OWN_FILTERS_DTO = 'document/salary-accrual-own-filters.dto',
  /** Salary accrual select API request body */
  SALARY_ACCRUAL_SELECT_DTO = 'document/salary-accrual-select.dto',
  /** Salary accrual sort API request body */
  SALARY_ACCRUAL_SORT_DTO = 'document/salary-accrual-sort.dto',
  /** Salary accrual query API request body */
  SALARY_ACCRUAL_QUERY_DTO = 'document/salary-accrual-query.dto',
  /** Salary accrual registry export to file API query parameters */
  SALARY_ACCRUAL_EXPORT_QUERY_DTO = 'document/salary-accrual-export-query.dto',
  /** Salary accrual page API response body */
  SALARY_ACCRUAL_PAGE_DTO = 'document/salary-accrual-page.dto',
  /** Document selection settings */
  DOCUMENT_SELECT_DTO = 'document/document-select.dto',
  /** Document sorting settings */
  DOCUMENT_SORT_DTO = 'document/document-sort.dto',
  /** Document plot sub-API query parameters */
  DOCUMENT_PLOT_QUERY_DTO = 'document/document-plot-query.dto',
  /** Document plot sub-API own settings */
  DOCUMENT_PLOT_SETTINGS_DTO = 'document/document-plot-settings.dto',
  /** Document subtotal sub-API item */
  DOCUMENT_SUBTOTAL_ITEM_DTO = 'document/document-subtotal-item.dto',
  /** Document subtotal sub-API query parameters */
  DOCUMENT_SUBTOTAL_QUERY_DTO = 'document/document-subtotal-query.dto',
  /** Document subtotal sub-API own settings */
  DOCUMENT_SUBTOTAL_SETTINGS_DTO = 'document/document-subtotal-settings.dto',
  /** Document subtotal sub-API response body */
  DOCUMENT_SUBTOTAL_DTO = 'document/document-subtotal.dto',
  /** Document total sub-API data */
  DOCUMENT_TOTAL_DATA_DTO = 'document/document-total-data.dto',
  /** Document total sub-API query parameters */
  DOCUMENT_TOTAL_QUERY_DTO = 'document/document-total-query.dto',
  /** Document total sub-API response body */
  DOCUMENT_TOTAL_DTO = 'document/document-total.dto',
  /** Documents bulk create API request body */
  DOCUMENT_BULK_CREATE_DTO = 'document/document-bulk-create.dto',
  /** Documents bulk update API item request body */
  DOCUMENT_BULK_FORM_DTO = 'document/document-bulk-form.dto',
  /** Documents bulk update API request body */
  DOCUMENT_BULK_UPDATE_DTO = 'document/document-bulk-update.dto',
  /** Document create API request body */
  DOCUMENT_CREATE_DTO = 'document/document-create.dto',
  /** Document registry and statistics APIs common filters */
  DOCUMENT_FILTERS_DTO = 'document/document-filters.dto',
  /** Document response body */
  DOCUMENT_FIND_DTO = 'document/document-find.dto',
  /** Document type create API request body */
  DOCUMENT_TYPE_CREATE_DTO = 'document/document-type-create.dto',
  /** Document types list API base filters */
  DOCUMENT_TYPE_FILTERS_DTO = 'document/document-type-filters.dto',
  /** Document type response body */
  DOCUMENT_TYPE_FIND_DTO = 'document/document-type-find.dto',
  /** Document type create and update APIs request body */
  DOCUMENT_TYPE_FORM_DTO = 'document/document-type-form.dto',
  /** Document type single CRUD APIs URL parameters */
  DOCUMENT_TYPE_PARAMS_DTO = 'document/document-type-params.dto',
  /** Document types list API query parameters */
  DOCUMENT_TYPE_QUERY_DTO = 'document/document-type-query.dto',
  /** Document type registry API query parameters */
  DOCUMENT_TYPE_REGISTRY_QUERY_DTO = 'document/document-type-registry-query.dto',
  /** Document type registry column selection parameters */
  DOCUMENT_TYPE_SELECT_DTO = 'document/document-type-select.dto',
  /** Document type registry sorting settings */
  DOCUMENT_TYPE_SORT_DTO = 'document/document-type-sort.dto',
  /** Document type registry items page */
  DOCUMENT_TYPE_ITEMS_PAGE_DTO = 'document/document-type-items-page.dto',
  /** Document type registry selectable item */
  DOCUMENT_TYPE_REGISTRY_SELECTABLE_ITEM_DTO = 'document/document-type-registry-selectable-item.dto',
  /** Document's flat list and statistics query parameters */
  DOCUMENT_FLAT_QUERY_DTO = 'document/document-flat-query.dto',
  /** Document create/update APIs request body */
  DOCUMENT_FORM_DTO = 'document/document-form.dto',
  /** Document registry API response body */
  DOCUMENT_PAGE_DTO = 'document/document-page.dto',
  /** Single document APIs URL parameters */
  DOCUMENT_PARAMS_DTO = 'document/document-params.dto',
  /** Document's list with pagination API query parameters */
  DOCUMENT_QUERY_DTO = 'document/document-query.dto',
  /** Document registry export to file API query parameters */
  DOCUMENT_EXPORT_QUERY_DTO = 'document/document-export-query.dto',
  /** Documents bulk deletion API request body */
  DOCUMENT_MULTIPLE_DELETE_DTO = 'document/document-multiple-delete.dto',
  /** Document split API request body item */
  DOCUMENT_SPLIT_CHUNK_DTO = 'document/document-split-chunk.dto',
  /** Document split API request body */
  DOCUMENT_SPLIT_DTO = 'document/document-split.dto',
  /** Document statistics API response body */
  DOCUMENT_STATISTICS_DTO = 'document/document-statistics.dto',
  /** Document template response body */
  DOCUMENT_TEMPLATE_FIND_DTO = 'document/document-template-find.dto',
  /** Document template create/update request body */
  DOCUMENT_TEMPLATE_FORM_DTO = 'document/document-template-form.dto',
  /** Document template search API query parameters */
  DOCUMENT_TEMPLATE_SEARCH_QUERY_DTO = 'document/document-template-search-query.dto',
  /** Document template registry column selection parameters */
  DOCUMENT_TEMPLATE_SELECT_DTO = 'document/document-template-select.dto',
  /** Document template registry sorting settings */
  DOCUMENT_TEMPLATE_SORT_DTO = 'document/document-template-sort.dto',
  /** Document template registry filters */
  DOCUMENT_TEMPLATE_FILTERS_DTO = 'document/document-template-filters.dto',
  /** Document template registry API query parameters */
  DOCUMENT_TEMPLATE_QUERY_DTO = 'document/document-template-query.dto',
  /** Document template registry export to file API query parameters */
  DOCUMENT_TEMPLATE_EXPORT_QUERY_DTO = 'document/document-template-export-query.dto',
  /** Document template registry items page */
  DOCUMENT_TEMPLATE_PAGE_DTO = 'document/document-template-page.dto',
  /** Document template registry total values */
  DOCUMENT_TEMPLATE_TOTAL_DATA_DTO = 'document/document-template-total-data.dto',
  /** Document template registry total API response body */
  DOCUMENT_TEMPLATE_TOTAL_DTO = 'document/document-template-total.dto',
  /** Document template registry total API query parameters */
  DOCUMENT_TEMPLATE_TOTAL_QUERY_DTO = 'document/document-template-total-query.dto',
  /** Document verify API parameters */
  DOCUMENT_VERIFY_BODY_DTO = 'document/document-verify-body.dto',
  /** Document verify API event entry */
  DOCUMENT_VERIFY_ENTRY_DTO = 'document/document-verify-entry.dto',
  /** Document verify API response body */
  DOCUMENT_VERIFY_RESULT_DTO = 'document/document-verify-result.dto',
  /** Document verify summary tab row response body */
  DOCUMENT_VERIFY_SUMMARY_ROW_DTO = 'document/document-verify-summary-row.dto',
  /** Document verify summary tab response body */
  DOCUMENT_VERIFY_SUMMARY_TAB_DTO = 'document/document-verify-summary-tab.dto',
  /** Document verify flat registry row */
  DOCUMENT_VERIFY_REGISTRY_ROW_FIND_DTO = 'document/document-verify-registry-row-find.dto',
  /** Document verify registry column selection parameters */
  DOCUMENT_VERIFY_SELECT_DTO = 'document/document-verify-select.dto',
  /** Document verify registry sorting settings */
  DOCUMENT_VERIFY_SORT_DTO = 'document/document-verify-sort.dto',
  /** Document verify synchronize-1c API request body */
  DOCUMENT_VERIFY_SYNC_BODY_DTO = 'document/document-verify-sync-body.dto',
  /** Document verify registry export to file API query parameters */
  DOCUMENT_VERIFY_EXPORT_QUERY_DTO = 'document/document-verify-export-query.dto',
  /** Bill own filters */
  BILL_FILTERS_DTO = 'document/bill-filters.dto',
  /** Bill find many API query parameters */
  BILL_FIND_MANY_QUERY_DTO = 'document/bill-find-many-query.dto',
  /** Bill registry export to file API query parameters */
  BILL_EXPORT_QUERY_DTO = 'document/bill-export-query.dto',
  /** Bill find one API query parameters (additional options) */
  BILL_FIND_ONE_QUERY_DTO = 'document/bill-find-one-query.dto',
  /** Bill response body */
  BILL_FIND_DTO = 'document/bill-find.dto',
  /** Bill create and update APIs request body */
  BILL_FORM_DTO = 'document/bill-form.dto',
  BILL_LIST_QUERY_DTO = 'document/bill-list-query.dto',
  BILL_PAGE_QUERY_DTO = 'document/bill-page-query.dto',
  BILL_PAGE_DTO = 'document/bill-page.dto',
  /** Bills plot API query parameters */
  BILL_PLOT_QUERY_DTO = 'document/bill-plot-query.dto',
  /** Bills plot API own settings */
  BILL_PLOT_SETTINGS_DTO = 'document/bill-plot-settings.dto',
  /** Bill selection parameters */
  BILL_SELECT_DTO = 'document/bill-select.dto',
  /** Bill sorting parameters */
  BILL_SORT_DTO = 'document/bill-sort.dto',
  BILL_STATISTICS_DTO = 'document/bill-statistics.dto',
  /** Bill registry subtotal grouping tab */
  BILL_SUBTOTAL_BY_DTO = 'document/bill-subtotal-by.dto',
  /** Bill registry subtotal API query parameters */
  BILL_SUBTOTAL_QUERY_DTO = 'document/bill-subtotal-query.dto',
  /** Bill registry subtotal row */
  BILL_SUBTOTAL_ITEM_DTO = 'document/bill-subtotal-item.dto',
  /** Bill registry subtotal response */
  BILL_SUBTOTAL_DTO = 'document/bill-subtotal.dto',
  /** Bill verify result entry response body */
  BILL_VERIFY_ENTRY_DTO = 'document/bill-verify-entry.dto',
  /** Bill verify API query parameters */
  BILL_VERIFY_QUERY_DTO = 'document/bill-verify-query.dto',
  /** Bill verify registry export base query (without select) */
  BILL_VERIFY_EXPORT_BASE_QUERY_DTO = 'document/bill-verify-export-base-query.dto',
  /** Bill verify registry export to file API query parameters */
  BILL_VERIFY_EXPORT_QUERY_DTO = 'document/bill-verify-export-query.dto',
  /** Flat bill verify registry row (for column select) */
  BILL_VERIFY_REGISTRY_ROW_FIND_DTO = 'document/bill-verify-registry-row-find.dto',
  /** Bill verify registry column selection parameters */
  BILL_VERIFY_SELECT_DTO = 'document/bill-verify-select.dto',
  /** Bill verify API response body */
  BILL_VERIFY_RESULT_DTO = 'document/bill-verify-result.dto',
  /** Bill verify summary tab row response body */
  BILL_VERIFY_SUMMARY_ROW_DTO = 'document/bill-verify-summary-row.dto',
  /** Bill verify summary tab response body */
  BILL_VERIFY_SUMMARY_TAB_DTO = 'document/bill-verify-summary-tab.dto',
  /** Credit/Debit exclusion own filters */
  CREDIT_DEBIT_EXCLUSION_FILTERS_DTO = 'document/credit-debit-exclusion-filters.dto',
  /** Credit/Debit exclusion response body */
  CREDIT_DEBIT_EXCLUSION_FIND_DTO = 'document/credit-debit-exclusion-find.dto',
  /** Credit/Debit exclusion registry find many query */
  CREDIT_DEBIT_EXCLUSION_FIND_MANY_QUERY_DTO = 'document/credit-debit-exclusion-find-many-query.dto',
  /** Credit/Debit exclusion registry export to file API query parameters */
  CREDIT_DEBIT_EXCLUSION_EXPORT_QUERY_DTO = 'document/credit-debit-exclusion-export-query.dto',
  /** Credit/Debit exclusion find one API query parameters */
  CREDIT_DEBIT_EXCLUSION_FIND_ONE_QUERY_DTO = 'document/credit-debit-exclusion-find-one-query.dto',
  /** Credit/debit exclusion registry selection options */
  CREDIT_DEBIT_EXCLUSION_SELECT_DTO = 'document/credit-debit-exclusion-select.dto',
  /** Credit/debit exclusion registry sort options */
  CREDIT_DEBIT_EXCLUSION_SORT_DTO = 'document/credit-debit-exclusion-sort.dto',
  /** Credit/debit exclusion registry items page */
  CREDIT_DEBIT_EXCLUSION_PAGE_DTO = 'document/credit-debit-exclusion-page.dto',
  /** Credit/Debit exclusion create and update APIs request body */
  CREDIT_DEBIT_EXCLUSION_FORM_DTO = 'document/credit-debit-exclusion-form.dto',
  /** Credit/Debit exclusion registry total values */
  CREDIT_DEBIT_EXCLUSION_TOTAL_DATA_DTO = 'document/credit-debit-exclusion-total-data.dto',
  /** Credit/Debit exclusion registry total API response body */
  CREDIT_DEBIT_EXCLUSION_TOTAL_DTO = 'document/credit-debit-exclusion-total.dto',
  /** Credit/Debit exclusion registry total API query parameters */
  CREDIT_DEBIT_EXCLUSION_TOTAL_QUERY_DTO = 'document/credit-debit-exclusion-total-query.dto',
  /** Contragent which must be created to save pending documents */
  BANK_STATEMENT_CONTRAGENT_FORM_DTO = 'document/bank-statement-contragent-form.dto',
  /** Pending documents submit form */
  BANK_STATEMENT_PENDING_DOCUMENTS_FORM_DTO = 'document/bank-statement-pending-documents-form.dto',
  /** Company which must be created to save pending documents */
  BANK_STATEMENT_COMPANY_FORM_DTO = 'document/bank-statement-company-form.dto',
  /** Company which must be created to save pending documents */
  BANK_STATEMENT_COMPANY_CREATE_FIND_DTO = 'document/bank-statement-company-create-find.dto',
  /** Data about document to create on contragents and companies submit */
  BANK_STATEMENT_DOCUMENT_FORM_DTO = 'document/bank-statement-document-form.dto',
  /** Contragent which must be created to save pending documents */
  BANK_STATEMENT_CONTRAGENT_CREATE_FIND_DTO = 'document/bank-statement-contragent-create-find.dto',
  /** Pending documents - contains contragents and companies which must be created by user before related documents will be created */
  BANK_STATEMENT_PENDING_DOCUMENTS_FIND_DTO = 'document/bank-statement-pending-documents-find.dto',
}
